<template lang='pug'>
v-app#vapp_10_1(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs11, sm10, md9, lg8, text-xs-center)
          v-card(flat)
            breadcrumb(back='page7-2')
              | Estás en: Elige tu Crédito Hipotecario / ¡Quiero contratar mi Crédito Hipotecario!
            v-card-text.text-xs-center.label16tt.withDivider
              | 2. VALIDA LOS REQUERIMIENTOS DEL INMUEBLE
            v-card-text.text-xs-center.titulo18Reg
              | Selecciona SI o NO cumples con cada uno de los requerimientos. Si no cumples, ¡checa qué puedes hacer para cumplirlos!
            v-layout.pb-0.ma-0(row, justify-center)
              v-flex.pb-0.ma-0(xs12)
                v-layout.pa-0.pl-4.ma-1.my-0.py-0(row, align-center)
                  v-flex.label16tt_blue.pa-0.ma-0.text-xs-left(xs8, sm8)
                    | REQUISITOS DEL INMUEBLE
                  v-flex.label16tt_blue.pa-0.ma-0.text-xs-left(xs8, sm8)
                    | INFORMACION
                  v-flex.pa-0.ma-0(xs2, sm2)
                    | CUMPLO / NO CUMPLO
                  v-flex.pl-4.ma-0(xs2, sm2)
            v-layout.pb-4.ma-0.pt-0(row, justify-center)
              v-flex.py-0.ma-0(xs12)
                v-layout.pa-0.pl-4.ma-1.leftBlueBorder(row, align-center, v-for='i in 7', :key='i')
                  v-flex.pa-0.ma-0.text-xs-left(xs8, sm8)
                    .parrafoDestacadoB.px-3
                      b {{reactivos[i-1].descripcion}}
                  v-flex.pa-0.ma-0.text-xs-left(xs8, sm8)
                    .parrafoDestacadoB.px-3(style="color:'#666666';") {{reactivos[i-1].informacion}}
                  v-flex.pa-0.ma-0(xs2, sm1)
                    v-btn.toggle.ma-1(:color='testValue(reactivos[i-1].respuesta, true)', @click.prevent='reactivos[i-1].respuesta=true;', block, value='true')
                      | Sí
                  v-flex.pa-0.ma-0(xs2, sm1)
                    v-btn.toggle.ma-2(:color='testValue(reactivos[i-1].respuesta, false)', @click.prevent='reactivos[i-1].respuesta=false;', block, value='false')
                      | No
                  v-flex.pl-4.ma-0(xs2, sm2)
                    v-popover(offset='16', placement='right', trigger='hover' :disabled='reactivos[i-1].respuesta == "none"')
                      v-icon.tooltip-target.info_tooltip(size='20px ', :color='testValue(reactivos[i-1].respuesta == "none", false)')
                        | fas fa-info-circle
                      template(slot='popover')
                        .pa-4
                          | {{ reactivos[i-1].tooltip}}
            
            v-btn#attachDialog_10_1.btn(depressed, justify-space-between, type='button ', color='secondary ', :disabled='!completo ', @click.prevent="nextPage( 'page7-2'); sendResult(); ")
              | Continuar
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import jsPDF from 'jspdf';
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      msg: 'This is a button',
      reactivos: [{
          descripcion: '1. Escritura de propiedad del inmueble y su constancia de inscripción en el Registro Público de la Propiedad.',
          informacion: 'El propietario del inmueble que deseas adquirir deberá proporcionar estos requisitos documentales.',
          respuesta: 'none',
          correcta: true,
          resultado: 'none',
          tooltip: 'Resuelve con el propietario que estos documentos se generen a través de los trámites correspondientes. De lo contrario, no podrás formalizar tu crédito.  ',
          nocumple: ['Resuelve con el propietario que estos documentos se generen a través de los trámites correspondientes.',
                    'De lo contrario, no podrás formalizar tu crédito.  ']
        },
        {
          descripcion: '2. Las últimas tres boletas de pago de consumo de agua y predial.',
          informacion:  'El propietario del inmueble que deseas adquirir deberá proporcionar estas boletas.',
          respuesta: 'none',
          correcta: true,
          resultado: 'none',
          tooltip: 'Es necesario que el pago de servicios e impuestos, como agua y predial, se encuentre al corriente. De lo contrario, podrías cargar con gastos que no te corresponden o tener problemas para formalizar tu crédito. ',
          nocumple: ['Es necesario que el pago de servicios e impuestos, como agua y predial, se encuentre al corriente. ',
                    'De lo contrario, podrías cargar con gastos que no te corresponden o tener problemas para formalizar ',
                    'tu crédito. ']
        },
        {
          descripcion: '3. Certificado de libertad de gravamen',
          informacion: 'Este documento es generado por un notario público y certifica que el inmueble está libre de todo gravamen, crédito hipotecario, juicio testamentario, etc. ',
          respuesta: 'none',
          correcta: true,
          resultado: 'none',
          tooltip: 'Si el inmueble no está libre de gravamen, será mejor que consideres otras opciones de vivienda.',
          nocumple: ['Si el inmueble no está libre de gravamen, será mejor que consideres otras opciones de vivienda.']
        },
        {
          descripcion: '4. Alineamiento y número oficial del inmueble expedido por la autoridad municipal.',
          informacion: 'Deberás confirmar este requisito con el propietario del inmueble.',
          respuesta: 'none',
          correcta: true,
          resultado: 'none',
          tooltip: 'Resuelve con el propietario que el trámite de este requisito se lleve a cabo. De lo contrario, no podrás formalizar tu crédito.',
          nocumple: ['Resuelve con el propietario que el trámite de este requisito se lleve a cabo. De lo contrario, ',
                    'no podrás formalizar tu crédito.']
        },
        {
          descripcion: '5. Avalúo fiscal vigente, realizado por un Perito.',
          informacion: 'Es la evaluación del valor del inmueble, hecha por un profesional autorizado.',
          respuesta: 'none',
          correcta: true,
          resultado: 'none',
          tooltip: 'Averigua las opciones de avalúo que ofrecen los diversos bancos que consultes.',
          nocumple: ['Averigua las opciones de avalúo que ofrecen los diversos bancos que consultes.']
        },
        {
          descripcion: '6. Dictamen técnico y de calidad con calificación mínima de 70 puntos (sólo en casas usadas).',
          informacion: 'Este formato evalúa las condiciones físicas y de seguridad en que se encuentra el inmueble.  ',
          respuesta: 'none',
          correcta: true,
          resultado: 'none',
          tooltip: 'Averigua qué opciones relacionadas con este requisito te ofrecen los diversos bancos que consultes.',
          nocumple: ['Averigua qué opciones relacionadas con este requisito te ofrecen los diversos bancos que consultes.']
        },
        {
          descripcion: '7. Contrato de compra-venta, firmado por el solicitante y el propietario.',
          informacion: 'Mediante este documento, el propietario te transfiere la posesión del inmueble a cambio del precio pactado. Se firma ante un notario público.  ',
          respuesta: 'none',
          correcta: true,
          resultado: 'none',
          tooltip: 'El contrato de compra-venta es indispensable para validar tu estatus de nuevo propietario y formalizar el crédito.',
          nocumple: ['El contrato de compra-venta es indispensable para validar tu estatus de nuevo propietario y ',
                    'formalizar el crédito.']
        }
      ],
      progress: false,
      dialog: false,
    }
  },
  computed: {
    completo: function() {
      var complete = true;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.respuesta == 'none') {
          complete = false;
        }
      })
      if (complete) {
        this.$parent.steps_calc.step2 = true;
      }
      return complete;
    },
    resultado: function() {
      var resultado = 0;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.respuesta == true) {
          resultado++;
        }
      })
      return resultado;
    }
  },
  methods: {
    downloadPDF() {
      var lineSpace = 7;
      var doc = new jsPDF()
      doc.text('Cumplimiento de requisitos para Crédito Hipotecario', 10, 10)
      doc.setFontSize(12);
      this.reactivos.forEach(function(reactivo, index) {
        if (reactivo.respuesta) {
          doc.setTextColor(0, 255, 0);
          doc.text("[Cumple]", 10, 20 + lineSpace * index);
        } else {
          doc.setTextColor(255, 0, 0);
          doc.text("[No Cumple]", 10, 20 + lineSpace * index);
        }
        doc.setTextColor(0, 0, 0);
        doc.text(reactivo.descripcion, 35, 20 + lineSpace * index);
      })
      doc.save('requisitos.pdf')
    },
    sendResult() {
      this.sent = true;
      this.$parent.results['page8-2'] = this.reactivos;
      this.$parent.results['page8-2-r'] = this.resultado;
    },
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    nextChapter(page) {
      this.progress = true;
      eventBus.$emit('next_chapter', page);
    },
    testValue(value, test) {
      if (value == test) {
        return 'accent';
      }
      return 'greyNormal'
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    }
  }
};
</script>
